export var BackupZeroEtlExtendedJsonMode;
(function (BackupZeroEtlExtendedJsonMode) {
    BackupZeroEtlExtendedJsonMode["BACKUP_ZERO_ETL_EXTENDED_JSON_MODE_NONE"] = "NONE";
    BackupZeroEtlExtendedJsonMode["BACKUP_ZERO_ETL_EXTENDED_JSON_MODE_MONGO"] = "MONGO";
})(BackupZeroEtlExtendedJsonMode || (BackupZeroEtlExtendedJsonMode = {}));
